module.exports = __webpack_public_path__ + "images/interview-American_express-2.svg";